import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames/bind';
import { BronzeStage } from '../../components/Plelander/BronzeStage';
import { SilverStage } from '../../components/Plelander/SilverStage';
import { GoldStage } from '../../components/Plelander/GoldStage';
import { Logo } from '../../components/Logo';
import { Button } from '../../components/Button';
import { ProgressiveImage } from '../../components/ProgressiveImage';
import { calculateTotal } from '../../lib/shared/number';
import { shuffleList } from '../../lib/shared/list';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';
import { preloadImages } from '../../lib/shared/preload-images';
import prelandCardImage1Src from '../../assets/images/prelander/preland-card-1.png';
import prelandCardImage2Src from '../../assets/images/prelander/preland-card-2.png';
import prelandCardImage3Src from '../../assets/images/prelander/preland-card-3.png';
import prelandCardImage4Src from '../../assets/images/prelander/preland-card-4.png';
import prelandCardImage5Src from '../../assets/images/prelander/preland-card-5.png';
import prelandCardImage6Src from '../../assets/images/prelander/preland-card-6.png';
import prelandCardImage7Src from '../../assets/images/prelander/preland-card-7.png';
import prelandCardImage8Src from '../../assets/images/prelander/preland-card-8.png';
import prelandCardImage9Src from '../../assets/images/prelander/preland-card-9.png';
import prelandCardImage10Src from '../../assets/images/prelander/preland-card-10.png';
import prelandCardImage11Src from '../../assets/images/prelander/preland-card-11.png';
import prelandCardImage12Src from '../../assets/images/prelander/preland-card-12.png';
import prelandCardImage13Src from '../../assets/images/prelander/preland-card-13.png';
import prelandCardImage14Src from '../../assets/images/prelander/preland-card-14.png';
import prelandCardImage15Src from '../../assets/images/prelander/preland-card-15.png';
import prelandCardImage16Src from '../../assets/images/prelander/preland-card-16.png';
import prelandCardImage17Src from '../../assets/images/prelander/preland-card-17.png';
import prelandCardImage18Src from '../../assets/images/prelander/preland-card-18.png';
import mainLeftImageSrc from '../../assets/images/prelander/main-left-image.png';
import mainRightImageSrc from '../../assets/images/prelander/main-right-image.png';
import previewCardImageSrc from '../../assets/images/prelander/dummy-card.png';
import decorImageSrc from '../../assets/images/prelander/decor.png';
import crownImageSrc from '../../assets/images/prelander/crown.png';
import questionImageSrc from '../../assets/images/prelander/question-modal.png';
import buddaImageSrc from '../../assets/images/prelander/budda-modal.png';
import statistics1ImageSrc from '../../assets/images/prelander/statistics-1.png';
import statistics2ImageSrc from '../../assets/images/prelander/statistics-2.png';
import statistics3ImageSrc from '../../assets/images/prelander/statistics-3.png';
import bronzeWinnerImageSrc from '../../assets/images/prelander/bronze-winner.png';
import smokeImageSrc from '../../assets/images/prelander/bg-smoke.png';
import particlesImageSrc from '../../assets/images/prelander/bg-particles.png';
import bgMobileImageSrc from '../../assets/images/prelander/bg-mobile-1.png';
import cardsImageSrc from '../../assets/images/prelander/cards-for-main.png';
import bundlesImageSrc from '../../assets/images/prelander/bundles-for-main.png';
import styles from './PrelanderGamePage.css';

const cx = classnames.bind(styles);

const CARDS = [
    {
        imageUrl: prelandCardImage1Src,
        id: 1,
        name: 'NiKo',
        captainRoleScore: 6,
        shooterRoleScore: 9,
        defenderRoleScore: 8,
        teamRoleScore: 8 
    },
    {
        imageUrl: prelandCardImage2Src,
        id: 2,
        name: 'device',
        captainRoleScore: 8,
        shooterRoleScore: 8,
        defenderRoleScore: 6,
        teamRoleScore: 8
    },
    {
        imageUrl: prelandCardImage3Src,
        id: 3,
        name: 'GeT_RiGhT',
        captainRoleScore: 6,
        shooterRoleScore: 8,
        defenderRoleScore: 7,
        teamRoleScore: 8
    },
    {
        imageUrl: prelandCardImage4Src,
        id: 4,
        name: 'blameF',
        captainRoleScore: 8,
        shooterRoleScore: 6,
        defenderRoleScore: 6,
        teamRoleScore: 8
    },
    {
        imageUrl: `${prelandCardImage5Src}?v=2`,
        id: 5,
        name: 'coldzera',
        captainRoleScore: 6,
        shooterRoleScore: 9,
        defenderRoleScore: 5,
        teamRoleScore: 8
    },
    {
        imageUrl: prelandCardImage6Src,
        id: 6,
        name: 'donk',
        captainRoleScore: 6,
        shooterRoleScore: 7,
        defenderRoleScore: 6,
        teamRoleScore: 8
    },
    {
        imageUrl: prelandCardImage7Src,
        id: 7,
        name: 'ropz',
        captainRoleScore: 6,
        shooterRoleScore: 7,
        defenderRoleScore: 6,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage8Src,
        id: 8,
        name: 'arT',
        captainRoleScore: 7,
        shooterRoleScore: 6,
        defenderRoleScore: 6,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage9Src,
        id: 9,
        name: 'broky',
        captainRoleScore: 5,
        shooterRoleScore: 6,
        defenderRoleScore: 7,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage10Src,
        id: 10,
        name: 'stavn',
        captainRoleScore: 4,
        shooterRoleScore: 7,
        defenderRoleScore: 7,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage11Src,
        id: 11,
        name: 'frozen',
        captainRoleScore: 4,
        shooterRoleScore: 8,
        defenderRoleScore: 5,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage12Src,
        id: 12,
        name: 'SunPayus',
        captainRoleScore: 5,
        shooterRoleScore: 6,
        defenderRoleScore: 6,
        teamRoleScore: 6
    },
    {
        imageUrl: `${prelandCardImage13Src}`,
        id: 13,
        name: 'KSCERATO',
        captainRoleScore: 6,
        shooterRoleScore: 6,
        defenderRoleScore: 5,
        teamRoleScore: 6
    },
    {
        imageUrl: prelandCardImage14Src,
        id: 14,
        name: 'k0nfig',
        captainRoleScore: 5,
        shooterRoleScore: 6,
        defenderRoleScore: 6,
        teamRoleScore: 4
    },
    {
        imageUrl: prelandCardImage15Src,
        id: 15,
        name: 'Brollan',
        captainRoleScore: 5,
        shooterRoleScore: 5,
        defenderRoleScore: 6,
        teamRoleScore: 4
    },
    {
        imageUrl: prelandCardImage16Src,
        id: 16,
        name: 'TeSeS',
        captainRoleScore: 5,
        shooterRoleScore: 7,
        defenderRoleScore: 4,
        teamRoleScore: 4
    },
    {
        imageUrl: prelandCardImage17Src,
        id: 17,
        name: 'floppy',
        captainRoleScore: 5,
        shooterRoleScore: 5,
        defenderRoleScore: 5,
        teamRoleScore: 4
    },
    {
        imageUrl: prelandCardImage18Src,
        id: 18,
        name: 'Maden',
        captainRoleScore: 4,
        shooterRoleScore: 5,
        defenderRoleScore: 4,
        teamRoleScore: 4
    }
];

const BRONZE_STAGE = 'bronzeStage';
const SILVER_STAGE = 'silverStage';
const GOLD_STAGE = 'goldStage';

const CAPTAIN = 'captain';
const DEFENDER = 'defender';
const SHOOTER = 'shooter';

const ROLES = [CAPTAIN, SHOOTER, DEFENDER];

const COEFFICIENT = 2.1;

const IMAGES = [
    previewCardImageSrc,
    ...CARDS.map(card => card.imageUrl),
    decorImageSrc,
    crownImageSrc,
    questionImageSrc,
    buddaImageSrc,
    statistics1ImageSrc,
    statistics2ImageSrc,
    statistics3ImageSrc,
    bronzeWinnerImageSrc
];

const INITIAL_PRELANDER = 'v1';

function PrelanderGamePage() {
    const randomCards = useMemo(() => shuffleList(CARDS), []);
    const [isPreview, setIsPreview] = useState(true);
    const [stage, setStage] = useState(BRONZE_STAGE);
    const [selectedCards, setSelectedCards] = useState([]);
    const [selectedRoleCards, setSelectedRoleCards] = useState({});
    const [selectedStarRole, setSeletedStarRole] = useState('');
    const teamPowerScore = useMemo(() => {
        const roleScore = Number(selectedRoleCards[CAPTAIN]?.captainRoleScore || 0) + Number(selectedRoleCards[DEFENDER]?.defenderRoleScore || 0) + Number(selectedRoleCards[SHOOTER]?.shooterRoleScore || 0);

        return calculateTotal(selectedCards, 'teamRoleScore') + roleScore;
    }, [selectedCards, selectedRoleCards]);
    const teamPowerScoreWithStarRole = useMemo(() => {
        return Math.round(Number(teamPowerScore) + Number(teamPowerScore * (selectedRoleCards?.[selectedStarRole]?.captainRoleScore * COEFFICIENT / 100 || 0)));
    }, [teamPowerScore, selectedStarRole]);

    useEffect(() => {
        logEvent(EVENT_TYPES.USER_PROPERTIES, {initialPrelander: INITIAL_PRELANDER});
        logEvent(EVENT_TYPES.PRELANDER_VISITED);

        if (isPreview) {
            preloadImages(IMAGES);
        }
    }, []);

    const selectCard = card => {
        setSelectedCards(prevState => ([...prevState, card]));
    };

    const selectRoleCard = (role, card) => {
        setSelectedRoleCards(prevState => ({...prevState, [role]: card}));
    };

    const selectStarRole = role => {
        setSeletedStarRole(role);
    };

    const nextSilverStage = () => {
        setStage(SILVER_STAGE);
    };

    const nextGoldStage = () => {
        setStage(GOLD_STAGE);
    };

    const restartGame = () => {
        setSelectedCards([]);
        setSelectedRoleCards({});
        setSeletedStarRole('');
        setStage(BRONZE_STAGE);
    };

    const renderStage = () => {
        if (isPreview) {
            return (
                <div className={styles.preview}>
                    <header className={styles.header}>
                        <Logo className={styles.logo}/>
                        <p className={styles.previewTitle}>
                            2 minutes mini-game
                        </p>
                    </header>
                    <div className={styles.previewMainBlock}>
                        <span className={styles.previewMainBlockStep}>
                            Step 1
                        </span>
                        <ProgressiveImage
                            src={`${cardsImageSrc}?v=2`}
                            alt='cards'
                            className={styles.previewMainBlockImage}
                        />
                        <h1 className={styles.previewMainBlockTitle}>
                            Build your CS2 Pro team
                        </h1>
                    </div>
                    <div className={styles.previewMainBlock}>
                        <span className={styles.previewMainBlockStep}>
                            Step 2
                        </span>
                        <ProgressiveImage
                            src={`${bundlesImageSrc}?v=2`}
                            alt='bundles'
                            className={styles.previewMainBlockImage}
                        />
                        <p className={styles.previewMainBlockTitle}>
                            Claim instant reward
                        </p>
                    </div>
                    <div>
                        <Button
                            onClick={() => setIsPreview(false)}
                            className={styles.mainButton}
                            label='Continue'
                        />
                        <p className={styles.copyrightText}>
                            Powerplay is developed independently and is not affiliated with or endorsed by the players, video game developers, esports teams or event holders depicted in the game.
                        </p>
                    </div>
                </div>
            )
        }

        if (stage === BRONZE_STAGE) {
            return (
                <BronzeStage
                    initialCards={randomCards}
                    selectedCards={selectedCards}
                    selectCard={selectCard}
                    finishStage={nextSilverStage}
                    teamPowerScore={teamPowerScore}
                />
            );
        };

        if (stage === SILVER_STAGE) {
            return (
                <SilverStage
                    initialCards={selectedCards}
                    finishStage={nextGoldStage}
                    selectRoleCard={selectRoleCard}
                    teamPowerScore={teamPowerScore}
                />
            );
        };

        if (stage === GOLD_STAGE) {
            return (
                <GoldStage
                    cards={ROLES.map(role => ({...(selectedRoleCards[role] || {}), role}))}
                    selectStarRole={selectStarRole}
                    selectedStarRole={selectedStarRole}
                    teamPowerScore={teamPowerScore}
                    teamPowerScoreWithStarRole={teamPowerScoreWithStarRole}
                    restart={restartGame}
                />
            );
        };

        return null;
    };

    return (
        <div className={cx('root', {withPreview: isPreview})}>
            <img
                className={cx('leftImage', {withPreview: isPreview})}
                alt='striker'
                src={mainLeftImageSrc}
            />
            {renderStage()}
            <img
                className={cx('rightImage', {withPreview: isPreview})}
                alt='striker'
                src={mainRightImageSrc}
            />
            <ProgressiveImage
                className={styles.backgroundPrimaryDesktop}
                alt='bg'
                src={smokeImageSrc}
            />
            <ProgressiveImage
                className={styles.backgroundSecondaryDesktop}
                alt='bg'
                src={particlesImageSrc}
            />
            <ProgressiveImage
                className={styles.backgroundMobile}
                alt='bg'
                src={`${bgMobileImageSrc}?v=2`}
            />
        </div>
    )
}

export {
    PrelanderGamePage
}
